/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_CopyInputs */

const en_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const de_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const fr_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const es_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const it_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const nl_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const pl_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const fi_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const da_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const sv_negotiation_copy = /** @type {(inputs: Negotiation_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Negotiation_CopyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_copy = /** @type {((inputs?: Negotiation_CopyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_CopyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_copy(inputs)
	if (locale === "fr") return fr_negotiation_copy(inputs)
	if (locale === "es") return es_negotiation_copy(inputs)
	if (locale === "it") return it_negotiation_copy(inputs)
	if (locale === "nl") return nl_negotiation_copy(inputs)
	if (locale === "pl") return pl_negotiation_copy(inputs)
	if (locale === "fi") return fi_negotiation_copy(inputs)
	if (locale === "da") return da_negotiation_copy(inputs)
	if (locale === "sv") return sv_negotiation_copy(inputs)
	return en_negotiation_copy(inputs)
});